import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { HalMark } from './HalMark';
import { AGENT_DOCS } from '../content/agentDocs';

export function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="site-footer-top">
        <div>
          <div className="nav-brand">
            {/* Home, at the top: on the homepage itself the route doesn't
                change, so scroll explicitly. */}
            <Link to="/" className="brand" title="Cloudish home" onClick={() => window.scrollTo({ top: 0 })}>
              <Logo height={20} />
            </Link>
            <HalMark height={20} />
          </div>
          <p className="faint small" style={{ marginTop: '.6rem', maxWidth: 320 }}>
            The Cloud for Agents. Get a key, deploy a Dockerfile, get a URL.
          </p>
        </div>
        <div className="site-footer-navs">
          <nav className="site-footer-links">
            <a href="/#features">Features</a>
            <a href="/#agents">For agents</a>
            <a href="/#pricing">Pricing</a>
            <a href="/#compare">Compare</a>
            <Link to="/logo">Logo</Link>
            <a href="/claim">Dashboard</a>
            <Link to="/help">Help</Link>
          </nav>
          {/* The agent documents as pages (pages/Doc.tsx), SKILL.md first.
              Plain links: each page arrives with its document already in it. */}
          <nav className="site-footer-links site-footer-docs" aria-label="Agent docs">
            {AGENT_DOCS.map((doc) => (
              <a key={doc.name} href={`/${doc.name}`}>
                {doc.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
      <div className="site-footer-bottom">
        <span className="site-footer-legal">
          <span>© {year} Cloudish</span>
          <a href="/terms">Terms</a>
          <a href="/privacy">Privacy</a>
        </span>
        <span>
          Created by{' '}
          <a href="https://hal9.com" target="_blank" rel="noreferrer">
            Hal9 Inc
          </a>
          , Redmond, WA
        </span>
      </div>
    </footer>
  );
}

export default SiteFooter;
